import React from 'react'
import PropTypes from 'prop-types'
import { Columns, LocalizedText, PromiseButtonIcon, Tooltip } from 'labguard-cdk'
import { useIntl } from 'react-intl'
import { RefreshIcon } from '../icons'
import styles from './ChannelsFilters.scss'
import ChannelNameFilter from './ChannelNameFilter'
import StatusFilter from './StatusFilter'

const ChannelsFilters = ({
  loading,
  total = 0,
  displayed = 0,
  hideStatusFilter = false,
  nameFilterPlaceholderKey,
  disabled,
  refetch,
}) => {
  const intl = useIntl()
  return (
    <Columns gap="1rem" align="center" justify="space-between" layout="1 auto auto auto">
      <ChannelNameFilter
        placeholder={nameFilterPlaceholderKey && intl.formatMessage({ id: nameFilterPlaceholderKey })}
        disabled={disabled}
      />
      {!hideStatusFilter && <StatusFilter disabled={disabled} />}
      <div className={styles.count}>
        {loading ? ' - ' : `${disabled ? '-' : displayed} ${total !== displayed ? `/ ${total}` : ''} `}
        <LocalizedText id="WEB_DISPLAYED_CHANNELS" values={{ count: displayed }} />
      </div>
      {refetch && (
        <Tooltip title={<LocalizedText id="WEB_REFRESH" />}>
          <PromiseButtonIcon icon={RefreshIcon} onClick={() => refetch()} />
        </Tooltip>
      )}
    </Columns>
  )
}

ChannelsFilters.propTypes = {
  loading: PropTypes.bool,
  total: PropTypes.number,
  displayed: PropTypes.number,
  hideStatusFilter: PropTypes.bool,
  disabled: PropTypes.bool,
  nameFilterPlaceholderKey: PropTypes.string,
  refetch: PropTypes.func,
}

export default ChannelsFilters
